import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "time-scroller"
}
const _hoisted_2 = { class: "more-indicator flex-center" }
const _hoisted_3 = {
  key: 0,
  class: "up-arrow"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "13",
  viewBox: "0 0 25 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.5 13C12.2091 13 11.9182 12.8938 11.6966 12.6826L0.333164 1.84925C0.00816947 1.53942 -0.0895561 1.07358 0.0865772 0.668416C0.261574 0.26325 0.677476 0 1.13656 0H23.8634C24.3225 0 24.7384 0.26325 24.9134 0.668416C25.0896 1.07358 24.9918 1.53942 24.6668 1.84925L13.3034 12.6826C13.0818 12.8938 12.7909 13 12.5 13Z",
    fill: "#DA3A34"
  })
], -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "next-prev-btn-container"
}
const _hoisted_7 = { class: "meeting-times" }
const _hoisted_8 = ["onMouseover", "onMouseleave", "onClick"]
const _hoisted_9 = { class: "time" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "more-indicator flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "down-arrow" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "25",
      height: "13",
      viewBox: "0 0 25 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.5 13C12.2091 13 11.9182 12.8938 11.6966 12.6826L0.333164 1.84925C0.00816947 1.53942 -0.0895561 1.07358 0.0865772 0.668416C0.261574 0.26325 0.677476 0 1.13656 0H23.8634C24.3225 0 24.7384 0.26325 24.9134 0.668416C25.0896 1.07358 24.9918 1.53942 24.6668 1.84925L13.3034 12.6826C13.0818 12.8938 12.7909 13 12.5 13Z",
        fill: "#DA3A34"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_11 = {
  key: 1,
  class: "noDays"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Sorry there are no more times available for this day!", -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.loadedDays.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.showArrow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["days-container", {smallerContainer: $setup.oneDayLoaded && $setup.lessThanFiveTimes}]),
          id: "scrollContainer",
          onScroll: $setup.onScroll
        }, [
          ($setup.showArrow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "previous-day borderless",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.getPreviousDay()))
                }, "Previous Day"),
                _createCommentVNode("TODO: possible async problem with getting days")
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loadedDays, (day, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "day",
              ref_for: true,
              ref: el => {$setup.scrollableDays[index] = {element:el,day:day[index]?.day}}
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["meeting-date", {isHovered: $setup.firstTimeHovered}])
              }, _toDisplayString($setup.formatDate(day[0].day)), 3 /* TEXT, CLASS */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day, (time, timeIndex) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "meeting-time",
                    onMouseover: ($event: any) => ($setup.checkForFirstElement(timeIndex,true)),
                    onMouseleave: ($event: any) => ($setup.checkForFirstElement(timeIndex,false)),
                    onClick: ($event: any) => ($setup.setMeetingInfo(time))
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(time.timeChunk.startTime.format("h:mma")), 1 /* TEXT */)
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */))
          }), 256 /* UNKEYED_FRAGMENT */)),
          _createCommentVNode(" .next-prev-btn-container// button.next-day.borderless(@click=\"getNextDay\") Next Day")
        ], 34 /* CLASS, HYDRATE_EVENTS */),
        _hoisted_10
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
}